import React from "react";
import PropTypes from "prop-types";
import SFAccordionCard from "./accordionCard";
import SFTypography from "../typography";
import { SFStack } from "../grid";
import SFBadgeIcons from "../badgeIcon";

const SFAccordionCardWithIcons = ({
  title,
  description,
  badges,
  badgesVariant,
  showHierarchy,
  expandClickIconOnly = true,
  expanded,
  onChange,
  maxItems,
}) => {
  return (
    <SFAccordionCard
      title={title}
      expanded={expanded}
      onChange={onChange}
      defaultExpanded
      expandClickIconOnly={expandClickIconOnly}
    >
      <SFStack spacing={2}>
        <SFTypography variant="body1" hasHtml>
          {description}
        </SFTypography>
        {badges && (
          <SFBadgeIcons
            badges={badges}
            variant={badgesVariant}
            showHierarchy={showHierarchy}
            maxItems={maxItems}
          />
        )}
      </SFStack>
    </SFAccordionCard>
  );
};

SFAccordionCardWithIcons.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  description: PropTypes.string.isRequired,
  showHierarchy: PropTypes.bool,
  maxItems: PropTypes.number,
  badges: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      description: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
        PropTypes.node,
      ]),
      iconColor: PropTypes.string,
      icon: PropTypes.element,
    })
  ),
  expandClickIconOnly: PropTypes.bool,
  onChange: PropTypes.func,
  expanded: PropTypes.bool,
};

export default SFAccordionCardWithIcons;
